import { Ionicons } from "@expo/vector-icons";
import {
  View,
  Text,
  TouchableOpacity,
  Alert,
  ScrollView,
  Modal,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, getDocs, deleteDoc, doc, setDoc } from "firebase/firestore";
import { useStateContext } from "../lib/context";
import { FlatList } from "react-native";

const Viajantes = ({ navigation, route }) => {
  const [viajantes, setViajantes] = useState([]);
  const [ready, setReady] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedViajante, setSelectedViajante] = useState(null);

  // Edit modal state
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingViajante, setEditingViajante] = useState(null);
  const [vendedores, setVendedores] = useState([]);
  const [selectedVendedores, setSelectedVendedores] = useState([]);
  const [loadingVendedores, setLoadingVendedores] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);

  const { currentUser } = useStateContext();

  useEffect(() => {
    getDocs(query(collection(db, "viajantes"))).then((docSnap) => {
      const fetchedViajantes = [];
      docSnap.forEach((doc) => {
        fetchedViajantes.push(doc.data());
      });
      fetchedViajantes.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setViajantes(fetchedViajantes);
      setReady(true);
    });
  }, []);

  useEffect(() => {
    viajantes.length > 0 ? setReady(true) : console.log("not ready yet");
  }, [viajantes]);

  const handleDelete = (viajante) => {
    setSelectedViajante(viajante);
    setModalVisible(true);
  };

  const confirmDelete = async () => {
    if (!selectedViajante) return;

    try {
      await deleteDoc(doc(db, "viajantes", selectedViajante.email));
      setViajantes(viajantes.filter((v) => v.email !== selectedViajante.email));
      setModalVisible(false);
      setSelectedViajante(null);
    } catch (error) {
      console.error("Error deleting viajante:", error);
      Alert.alert("Error", "No se pudo eliminar el viajante");
    }
  };

  const cancelDelete = () => {
    setModalVisible(false);
    setSelectedViajante(null);
  };

  // Fetch vendedores from vendedoresdrn collection
  const fetchVendedores = async () => {
    setLoadingVendedores(true);
    try {
      const vendedoresRef = collection(db, "vendedoresdrn");
      const snapshot = await getDocs(vendedoresRef);
      const vendedoresList = [];
      snapshot.forEach((doc) => {
        vendedoresList.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setVendedores(vendedoresList);
    } catch (error) {
      console.error("Error fetching vendedores:", error);
      Alert.alert("Error", "No se pudieron cargar los vendedores de 3C");
    } finally {
      setLoadingVendedores(false);
    }
  };

  const handleEdit = async (viajante) => {
    setEditingViajante(viajante);

    // Get current selected vendedores (support both old and new structure)
    let currentVendedores = [];
    if (viajante.vendedores3C && Array.isArray(viajante.vendedores3C)) {
      currentVendedores = viajante.vendedores3C;
    } else if (viajante.vendedor3C) {
      currentVendedores = [viajante.vendedor3C];
    }
    setSelectedVendedores(currentVendedores);

    // Fetch vendedores if not already loaded
    if (vendedores.length === 0) {
      await fetchVendedores();
    }

    setEditModalVisible(true);
  };

  const handleToggleVendedor = (vendedor) => {
    setSelectedVendedores((prev) => {
      const isSelected = prev.some((v) => v.id === vendedor.id);
      if (isSelected) {
        return prev.filter((v) => v.id !== vendedor.id);
      } else {
        return [...prev, vendedor];
      }
    });
  };

  const saveEdit = async () => {
    if (!editingViajante) return;

    if (selectedVendedores.length === 0) {
      Alert.alert("Error", "Debe seleccionar al menos una cuenta de 3C");
      return;
    }

    setSavingEdit(true);
    try {
      await setDoc(
        doc(db, "viajantes", editingViajante.email),
        {
          vendedores3C: selectedVendedores.map((v) => ({ ...v })),
        },
        { merge: true }
      );

      // Update local state
      setViajantes((prev) =>
        prev.map((v) =>
          v.email === editingViajante.email
            ? { ...v, vendedores3C: selectedVendedores, vendedor3C: undefined }
            : v
        )
      );

      setEditModalVisible(false);
      setEditingViajante(null);
      Alert.alert("Éxito", "Cuentas de 3C actualizadas correctamente");
    } catch (error) {
      console.error("Error saving edit:", error);
      Alert.alert("Error", "No se pudieron guardar los cambios");
    } finally {
      setSavingEdit(false);
    }
  };

  const cancelEdit = () => {
    setEditModalVisible(false);
    setEditingViajante(null);
    setSelectedVendedores([]);
  };

  if (!ready) {
    return (
      <View style={localStyles.container}>
        <View style={localStyles.header}>
          <TouchableOpacity onPress={() => navigation.goBack()} style={localStyles.backButton}>
            <Ionicons name="arrow-back" size={24} color="#fff" />
          </TouchableOpacity>
          <Text style={localStyles.headerTitle}>Viajantes</Text>
        </View>
        <View style={localStyles.loadingContainer}>
          <ActivityIndicator size="large" color="#2a2a8e" />
          <Text style={localStyles.loadingText}>Cargando...</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={localStyles.container}>
      {/* Header */}
      <View style={localStyles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()} style={localStyles.backButton}>
          <Ionicons name="arrow-back" size={24} color="#fff" />
        </TouchableOpacity>
        <Text style={localStyles.headerTitle}>Viajantes</Text>
        <View style={localStyles.badge}>
          <Text style={localStyles.badgeText}>{viajantes.length}</Text>
        </View>
      </View>

      <ScrollView
        style={localStyles.scrollView}
        contentContainerStyle={localStyles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {viajantes.length === 0 ? (
          <View style={localStyles.emptyContainer}>
            <Ionicons name="people-outline" size={64} color="#ccc" />
            <Text style={localStyles.emptyText}>No hay viajantes registrados</Text>
            <Text style={localStyles.emptySubtext}>
              Presiona el botón + para agregar uno nuevo
            </Text>
          </View>
        ) : (
          viajantes.map((item) => {
            // Get cuentas to display (support both old and new structure)
            const cuentas = item.vendedores3C && Array.isArray(item.vendedores3C)
              ? item.vendedores3C
              : item.vendedor3C
                ? [item.vendedor3C]
                : [];

            return (
              <View key={item.id || item.email || item.fecha} style={localStyles.card}>
                <TouchableOpacity
                  onPress={() => navigation.navigate("ViajanteDetail", item)}
                  style={localStyles.cardContent}
                >
                  <View style={localStyles.avatarContainer}>
                    <Ionicons name="person" size={24} color="#2a2a8e" />
                  </View>
                  <View style={localStyles.infoContainer}>
                    <Text style={localStyles.name}>{item.name || "Sin nombre"}</Text>
                    <View style={localStyles.infoRow}>
                      <Ionicons name="mail-outline" size={14} color="#666" />
                      <Text style={localStyles.infoText}>{item.email || "Sin correo"}</Text>
                    </View>
                    {cuentas.length > 0 && (
                      <View style={localStyles.cuentasContainer}>
                        <View style={localStyles.infoRow}>
                          <Ionicons name="briefcase-outline" size={14} color="#666" />
                          <Text style={localStyles.infoText}>
                            {cuentas.length === 1
                              ? cuentas[0].APELLIDOYNOMBRE
                              : `${cuentas.length} cuentas de 3C`}
                          </Text>
                        </View>
                        {cuentas.length > 1 && (
                          <View style={localStyles.cuentasList}>
                            {cuentas.slice(0, 3).map((cuenta, idx) => (
                              <Text key={cuenta.id || idx} style={localStyles.cuentaTag}>
                                {cuenta.APELLIDOYNOMBRE}
                              </Text>
                            ))}
                            {cuentas.length > 3 && (
                              <Text style={localStyles.cuentaMore}>+{cuentas.length - 3} más</Text>
                            )}
                          </View>
                        )}
                      </View>
                    )}
                  </View>
                  <Ionicons name="chevron-forward" size={20} color="#999" />
                </TouchableOpacity>

                {/* Action Buttons */}
                <View style={localStyles.actionButtons}>
                  <TouchableOpacity
                    onPress={() => handleEdit(item)}
                    style={localStyles.editButton}
                  >
                    <Ionicons name="pencil-outline" size={18} color="#fff" />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => handleDelete(item)}
                    style={localStyles.deleteButton}
                  >
                    <Ionicons name="trash-outline" size={18} color="#fff" />
                  </TouchableOpacity>
                </View>
              </View>
            );
          })
        )}
      </ScrollView>

      {/* Floating Add Button */}
      <TouchableOpacity
        style={localStyles.fab}
        onPress={() => navigation.navigate("AltaViajante")}
      >
        <Ionicons name="add" size={32} color="#fff" />
      </TouchableOpacity>

      {/* Delete Confirmation Modal */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={cancelDelete}
      >
        <View style={localStyles.modalOverlay}>
          <View style={localStyles.modalView}>
            <View style={localStyles.modalIconContainer}>
              <Ionicons name="warning" size={48} color="#ff4444" />
            </View>
            <Text style={localStyles.modalTitle}>Confirmar Eliminación</Text>
            <Text style={localStyles.modalText}>
              ¿Está seguro que desea eliminar a{" "}
              <Text style={localStyles.modalNameHighlight}>
                {selectedViajante?.name || "este viajante"}
              </Text>
              ?
            </Text>
            <Text style={localStyles.modalWarning}>Esta acción no se puede deshacer</Text>
            <View style={localStyles.modalButtons}>
              <TouchableOpacity
                style={[localStyles.modalButton, localStyles.cancelButton]}
                onPress={cancelDelete}
              >
                <Text style={localStyles.cancelButtonText}>Cancelar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[localStyles.modalButton, localStyles.deleteModalButton]}
                onPress={confirmDelete}
              >
                <Text style={localStyles.deleteButtonText}>Eliminar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Edit Cuentas Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={editModalVisible}
        onRequestClose={cancelEdit}
      >
        <View style={localStyles.editModalOverlay}>
          <View style={localStyles.editModalContainer}>
            <View style={localStyles.editModalHeader}>
              <Text style={localStyles.editModalTitle}>Editar Cuentas de 3C</Text>
              <TouchableOpacity onPress={cancelEdit} style={localStyles.closeButton}>
                <Ionicons name="close" size={24} color="#666" />
              </TouchableOpacity>
            </View>

            {editingViajante && (
              <View style={localStyles.editingInfo}>
                <Text style={localStyles.editingName}>{editingViajante.name}</Text>
                <Text style={localStyles.editingEmail}>{editingViajante.email}</Text>
              </View>
            )}

            {selectedVendedores.length > 0 && (
              <View style={localStyles.selectedCount}>
                <Text style={localStyles.selectedCountText}>
                  {selectedVendedores.length} cuenta(s) seleccionada(s)
                </Text>
              </View>
            )}

            {loadingVendedores ? (
              <View style={localStyles.loadingContainer}>
                <ActivityIndicator size="large" color="#2a2a8e" />
                <Text style={localStyles.loadingText}>Cargando vendedores...</Text>
              </View>
            ) : (
              <FlatList
                data={vendedores}
                keyExtractor={(item) => item.id}
                contentContainerStyle={localStyles.vendedorListContent}
                renderItem={({ item }) => {
                  const isSelected = selectedVendedores.some((v) => v.id === item.id);
                  return (
                    <TouchableOpacity
                      style={[
                        localStyles.vendedorItem,
                        isSelected && localStyles.vendedorItemSelected,
                      ]}
                      onPress={() => handleToggleVendedor(item)}
                    >
                      <View style={[
                        localStyles.vendedorAvatar,
                        isSelected && localStyles.vendedorAvatarSelected
                      ]}>
                        <Text style={localStyles.vendedorAvatarText}>
                          {item.APELLIDOYNOMBRE ? item.APELLIDOYNOMBRE.charAt(0) : "?"}
                        </Text>
                      </View>
                      <View style={localStyles.vendedorInfo}>
                        <Text style={localStyles.vendedorName}>
                          {item.APELLIDOYNOMBRE || "Sin nombre"}
                        </Text>
                        {item.CODIGO && (
                          <Text style={localStyles.vendedorCode}>Código: {item.CODIGO}</Text>
                        )}
                      </View>
                      <View style={[
                        localStyles.checkbox,
                        isSelected && localStyles.checkboxSelected
                      ]}>
                        {isSelected && (
                          <Ionicons name="checkmark" size={16} color="#fff" />
                        )}
                      </View>
                    </TouchableOpacity>
                  );
                }}
                ListEmptyComponent={
                  <View style={localStyles.emptyContainer}>
                    <Ionicons name="search" size={48} color="#ddd" />
                    <Text style={localStyles.emptyText}>No se encontraron vendedores</Text>
                  </View>
                }
              />
            )}

            <View style={localStyles.editModalFooter}>
              <TouchableOpacity
                style={[localStyles.footerButton, localStyles.footerCancelButton]}
                onPress={cancelEdit}
              >
                <Text style={localStyles.footerCancelText}>Cancelar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  localStyles.footerButton,
                  localStyles.footerSaveButton,
                  savingEdit && localStyles.footerButtonDisabled
                ]}
                onPress={saveEdit}
                disabled={savingEdit}
              >
                {savingEdit ? (
                  <ActivityIndicator size="small" color="#fff" />
                ) : (
                  <Text style={localStyles.footerSaveText}>Guardar</Text>
                )}
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default Viajantes;

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  header: {
    backgroundColor: "#2a2a8e",
    paddingTop: 50,
    paddingBottom: 20,
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "center",
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  backButton: {
    padding: 4,
    marginRight: 12,
  },
  headerTitle: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#fff",
    flex: 1,
  },
  badge: {
    backgroundColor: "rgba(255,255,255,0.2)",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  badgeText: {
    color: "#fff",
    fontWeight: "600",
    fontSize: 14,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: 20,
    paddingBottom: 100,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: "#666",
  },
  emptyContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 60,
  },
  emptyText: {
    fontSize: 18,
    fontWeight: "600",
    color: "#999",
    marginTop: 16,
  },
  emptySubtext: {
    fontSize: 14,
    color: "#bbb",
    marginTop: 8,
    textAlign: "center",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
    overflow: "hidden",
  },
  cardContent: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
  },
  avatarContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "#E8EAF6",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  infoContainer: {
    flex: 1,
  },
  name: {
    fontSize: 16,
    fontWeight: "600",
    color: "#333",
    marginBottom: 4,
  },
  infoRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 2,
  },
  infoText: {
    fontSize: 13,
    color: "#666",
    marginLeft: 6,
  },
  actionButtons: {
    position: "absolute",
    top: 12,
    right: 12,
    flexDirection: "row",
    gap: 8,
  },
  editButton: {
    backgroundColor: "#2a2a8e",
    padding: 8,
    borderRadius: 8,
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },
  deleteButton: {
    backgroundColor: "#ff4444",
    padding: 8,
    borderRadius: 8,
    shadowColor: "#ff4444",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },
  cuentasContainer: {
    marginTop: 4,
  },
  cuentasList: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 4,
    gap: 4,
  },
  cuentaTag: {
    backgroundColor: "#E8EAF6",
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    fontSize: 11,
    color: "#2a2a8e",
  },
  cuentaMore: {
    fontSize: 11,
    color: "#999",
    paddingVertical: 2,
  },
  fab: {
    position: "absolute",
    right: 24,
    bottom: 32,
    backgroundColor: "#2a2a8e",
    borderRadius: 32,
    width: 56,
    height: 56,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 5,
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  modalView: {
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 32,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    maxWidth: 400,
    width: "90%",
  },
  modalIconContainer: {
    marginBottom: 16,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#333",
    marginBottom: 12,
  },
  modalText: {
    fontSize: 15,
    color: "#666",
    textAlign: "center",
    marginBottom: 8,
    lineHeight: 22,
  },
  modalNameHighlight: {
    fontWeight: "600",
    color: "#2a2a8e",
  },
  modalWarning: {
    fontSize: 13,
    color: "#999",
    fontStyle: "italic",
    marginBottom: 24,
  },
  modalButtons: {
    flexDirection: "row",
    gap: 12,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 10,
    minWidth: 120,
  },
  cancelButton: {
    backgroundColor: "#E0E0E0",
  },
  cancelButtonText: {
    color: "#666",
    fontWeight: "600",
    textAlign: "center",
    fontSize: 15,
  },
  deleteModalButton: {
    backgroundColor: "#ff4444",
  },
  deleteButtonText: {
    color: "#fff",
    fontWeight: "600",
    textAlign: "center",
    fontSize: 15,
  },
  // Edit Modal Styles
  editModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-end",
  },
  editModalContainer: {
    backgroundColor: "#fff",
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    height: "85%",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 10,
  },
  editModalHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
  editModalTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#333",
  },
  closeButton: {
    padding: 4,
  },
  editingInfo: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    backgroundColor: "#F4F6FD",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
  editingName: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2a2a8e",
  },
  editingEmail: {
    fontSize: 14,
    color: "#666",
    marginTop: 2,
  },
  selectedCount: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: "#E3F2FD",
  },
  selectedCountText: {
    color: "#2a2a8e",
    fontWeight: "600",
    fontSize: 14,
  },
  vendedorListContent: {
    padding: 16,
  },
  vendedorItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    marginBottom: 8,
    backgroundColor: "#fff",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E0E0E0",
  },
  vendedorItemSelected: {
    backgroundColor: "#E3F2FD",
    borderColor: "#2a2a8e",
  },
  vendedorAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#F4F6FD",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  vendedorAvatarSelected: {
    backgroundColor: "#2a2a8e",
  },
  vendedorAvatarText: {
    color: "#2a2a8e",
    fontWeight: "600",
    fontSize: 16,
  },
  vendedorInfo: {
    flex: 1,
  },
  vendedorName: {
    fontSize: 15,
    fontWeight: "600",
    color: "#333",
    marginBottom: 2,
  },
  vendedorCode: {
    fontSize: 13,
    color: "#666",
  },
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: "#ccc",
    justifyContent: "center",
    alignItems: "center",
  },
  checkboxSelected: {
    backgroundColor: "#2a2a8e",
    borderColor: "#2a2a8e",
  },
  editModalFooter: {
    flexDirection: "row",
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: "#eee",
    gap: 12,
  },
  footerButton: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: "center",
  },
  footerCancelButton: {
    backgroundColor: "#E0E0E0",
  },
  footerCancelText: {
    color: "#666",
    fontSize: 16,
    fontWeight: "600",
  },
  footerSaveButton: {
    backgroundColor: "#2a2a8e",
  },
  footerSaveText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
  footerButtonDisabled: {
    opacity: 0.6,
  },
});
